import React from "react";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import { formatDateValue, transformFieldNames } from "../utils";
import { StorageProductRelationHistoryAction } from "@me-team/host/main/graphql/types";

export interface IHistoryData {
    field?: string;
    value?: string;
    id?: number;
    storage?: { name: string };
    employee?: { name?: string; surname?: string };
    client?: { name?: string; phone?: string; email?: string };
}

interface OperationHistoryDataItemProps {
    historyData: IHistoryData;
    isCreate: boolean;
    previousData?: IHistoryData;
    isMandatory?: boolean;
    operationType?: string;
}

const OperationHistoryDataItem: React.FC<OperationHistoryDataItemProps> = ({
    historyData,
    isCreate,
    previousData,
    isMandatory = false,
    operationType,
}) => {
    const { t } = useTranslation();

    if (
        (historyData.field === "price" || historyData.field === "cost") &&
        operationType !== StorageProductRelationHistoryAction.Sale
    ) {
        return null;
    }

    const renderFieldChange = () => {
        if (!isMandatory && previousData && previousData.value === historyData.value) {
            return null;
        }

        const fieldName = t(transformFieldNames(historyData.field));
        const formattedValue = formatDateValue(historyData);
        const formattedOldValue = previousData ? formatDateValue(previousData) : null;

        const isOperationField = historyData.field === "Operation";

        if (isMandatory || isCreate) {
            return (
                <>
                    <span className="text-grey">{fieldName}:</span>
                    <span className={`ms-1 ${isOperationField && "text-pink"}`}>{formattedValue}</span>
                </>
            );
        }

        if (!previousData) {
            return (
                <>
                    <span className="text-grey">{fieldName}:</span>
                    <span className="ms-1">{formattedValue}</span>
                </>
            );
        }

        return (
            <>
                <Col xs={12} lg={"auto"}>
                    <span className="text-grey">{fieldName}:</span>
                    <span className="ms-1">{formattedOldValue}</span>
                </Col>
                <Col xs={12} lg={"auto"}>
                    <i className="bi bi-arrow-right px-1 text-grey"></i>
                    <span className="text-grey">{fieldName}:</span>
                    <span className="ms-1">{formattedValue}</span>
                </Col>
            </>
        );
    };

    return <p className="mb-2 mb-lg-1">{renderFieldChange()}</p>;
};

export default OperationHistoryDataItem;
